import { render, staticRenderFns } from "./partnership-detail.vue?vue&type=template&id=94be8cfa&scoped=true&"
import script from "./partnership-detail.vue?vue&type=script&lang=js&"
export * from "./partnership-detail.vue?vue&type=script&lang=js&"
import style0 from "./partnership-detail.vue?vue&type=style&index=0&id=94be8cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94be8cfa",
  null
  
)

export default component.exports